module.exports = __webpack_public_path__ + "static/media/layers.2e917f33.svg";